import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Form, Card, Button } from "antd";
import { LeftCircleTwoTone } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";
import AndtDPasswordBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/PasswordBoxWrapper";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  notificationTitle,
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import { localStorageVariableName } from "swfrontend/AppConfigs";
import AuthDataProvider from "../../AuthDataProvider";
import Timer from "./Timer";
import { URLS, validator_messages } from "../../constants";
import { strongPasswordValidator } from "../../validators"
import { NOTIFICATIONS } from "../../../LandingPage/constants";

class ResetPassword extends Component {
  formRef = React.createRef();
  DataProvider = new AuthDataProvider();

  state = {
    isLoading: false,
    username: localStorage.getItem(localStorageVariableName.userName),
  };

  onFinish = (values) => {
    if (values["npassword"] !== values["cpassword"]) {
      openNotification(
        openNotificationType.error,
        notificationTitle.form,
        validator_messages.CONFIRM_PASSWORD
      );
    } else {
      Object.keys(values).forEach((each) => {
        values[each] = window.btoa(values[each].trim())
      });
      this.resetPassword(values);
    }
  };

  resetPassword = (values) => {
    try {
      this.setState({ isLoading: true });
      this.DataProvider.post_api_call(`${URLS.RESET_PASSWORD}`, values)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              Object.keys(res).map((success) => {
                openNotification(
                  openNotificationType.success,
                  success,
                  res[success]
                );
              });

              localStorage.clear();
              this.formRef.current.resetFields();
              this.props.history.push(URLS.LOGIN_URL);
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  goBack = () => {
    try {
      this.props.history.goBack();
      // this.props.history.push(URLS.FORGET_PASSWORD_URL);
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { isLoading } = this.props;

    return (
      <>
        <Modal show={isLoading} centered>
          <Modal.Body>
            <FormLoader loading="true" />
          </Modal.Body>
        </Modal>

        <Form
          onFinish={this.onFinish}
          layout="vertical"
          ref={this.formRef}
          className="container_bg text-center"
          autoComplete="off"
        >
          <Card
            title="Reset Password"
            className="main_card p-1"
            extra={
              <Button type="link">
                <LeftCircleTwoTone
                  onClick={this.goBack}
                  className="back-icon"
                />
              </Button>
            }
          >
            <div className="col-lg-12 col-md-12 text-right">
              <Timer formRef={this.formRef} />
            </div>

            <div className="col-lg-12 col-md-12">
              <AndtDPasswordBoxWrapper
                decorator="npassword"
                id="NPassword"
                required="true"
                label="New Password"
                message="Enter New Password"
                placeholder="Enter New Password"
                validators={[{ validator: strongPasswordValidator }]}
                formRef={this.formRef}
              />
            </div>

            <div className="col-lg-12 col-md-12">
              <AndtDPasswordBoxWrapper
                decorator="cpassword"
                id="CPassword"
                required="true"
                label="Confirm Password"
                message="Enter Confirm Password"
                placeholder="Enter Confirm Password"
                validators=""
                formRef={this.formRef}
              />
            </div>

            <div className="col-lg-12 col-md-12 text-center">
              <Button htmlType="submit" type="primary" id="resetpassword">
                Submit
              </Button>
            </div>
          </Card>
        </Form>
        <br />
        <br />
        <br />
      </>
    );
  }
}

export default withRouter(ResetPassword);
